/**
 * App logger — the shared fleet logger (@owlcat/logger).
 *
 * Structured JSON in prod (Loki-parseable), human-readable + rotating file in
 * dev, AsyncLocalStorage trace-correlation on the server (each request runs in
 * a trace scope via instrumentation), edge/browser-safe (console fallback, no
 * fs/async_hooks in those bundles). Kept as a re-export so existing
 * `import { logger } from "@/shared/infrastructure/logging/logger"` call sites
 * keep working — signature `logger.info(msg, meta?)` is compatible (a single
 * object arg becomes structured context).
 */
export { logger } from "@owlcat/logger";
